export default {
  Language: [
    {
      key: 'Fa', text: 'فارسی', value: 0, badge: 'info',
    },
    {
      key: 'En', text: 'انگلیسی', value: 1, badge: 'success',
    },
    {
      key: 'Ar', text: 'عربی', value: 2, badge: 'warning',
    },
  ],
  Status: [
    {
      key: 'Pending', text: 'در حال بررسی', value: 0, badge: 'secondary',
    },
    {
      key: 'Accepted', text: 'تایید شده', value: 1, badge: 'success',
    },
    {
      key: 'Failed', text: 'رد شده', value: 2, badge: 'warning',
    },
  ],
  StopDiet: [
    {
      text: 'آزاد', value: false,
    },
    {
      text: 'خطرناک', value: true,
    },
  ],
  Level: [
    {
      key: 'Beginner', text: 'مقدماتی', value: 0, badge: 'secondary',
    },
    {
      key: 'Intermediate', text: 'پیشرفته', value: 1, badge: 'info',
    },
    {
      key: 'Advanced', text: 'حرفه ای', value: 2, badge: 'warning',
    },
    {
      key: 'Professional', text: 'فوق حرفه ای', value: 3, badge: 'danger',
    },
  ],
  IsPaid: [
    {
      text: 'پرداخت شده', value: true,
    },
    {
      text: 'پرداخت نشده', value: false,
    },
  ],
  IsActive: [
    {
      text: 'فعال', value: true, badge: 'success',
    },
    {
      text: 'غیرفعال', value: false, badge: 'secondary',
    },
  ],
  IsDeactive: [
    {
      text: 'غیرفعال', value: true,
    },
    {
      text: 'فعال', value: false,
    },
  ],
  UserStatus: [
    {
      text: 'تکمیل پروفایل', value: 0, badge: 'info',
    },
    {
      text: 'اطلاعات سایز', value: 1, badge: 'info',
    },
    {
      text: 'پرسش و پاسخ', value: 2, badge: 'info',
    },
    {
      text: 'بررسی پرسش و پاسخ', value: 3, badge: 'primary',
    },
    {
      text: 'سوال اختصاصی', value: 4, badge: 'info',
    },
    {
      text: 'آماده سازی رژیم', value: 5, badge: 'primary',
    },
    {
      text: 'استفاده از رژیم', value: 6, badge: 'success',
    },
    {
      text: 'وزن کشی 14 روزه', value: 7, badge: 'success',
    },
    {
      text: 'هشدار تمدید رژیم', value: 8, badge: 'warning',
    },
    {
      text: 'نیاز به تمدید رژیم', value: 9, badge: 'warning',
    },
    {
      text: 'غیرفعال', value: 10, badge: 'secondary',
    },
  ],
  Company: [
    {
      text: 'زیره', value: 0, badge: 'success',
    },
    {
      text: 'کارسو', value: 1, badge: 'secondary',
    },
  ],
  Target: [
    {
      key: 'Zireh', text: 'زیره', value: 0
    },
    {
      key: 'ZirehPlus', text: 'زیره پلاس', value: 1
    },
  ],
  ContentType: [
    {
      key: 'Onboarding', text: 'معرفی زیره', value: 0,
    },
    {
      key: 'Disclaimer', text: 'سلب مسئولیت', value: 1,
    },
  ],
  Entity: [
    {
      key: 'Food', text: 'غذا', value: 0,
    },
    {
      key: 'Activity', text: 'فعالیت', value: 1,
    },
    {
      key: 'Blog', text: 'مجله', value: 2,
    },
    {
      key: 'FoodComment', text: 'نظرات', value: 3,
    },
  ],
  ReportStatus: [
    {
      key: 'New', text: 'جدید', value: 0, badge: 'success',
    },
    {
      key: 'InProgress', text: 'در حال بررسی', value: 1, badge: 'warning',
    },
    {
      key: 'Closed', text: 'بسته شده', value: 2, badge: 'secondary',
    },
  ],
  AmountType: [
    {
      key: 'Percent', text: 'درصد', value: 0,
    },
    {
      key: 'Price', text: 'مبلغ', value: 1,
    },
  ],
  Advertiser: [
    {
      key: 'Zireh', text: 'زیره', value: 0,
    },
    {
      key: 'Tapsell', text: 'تپسل', value: 1,
    },
    {
      key: 'AdMobe', text: 'گوگل', value: 2,
    },
  ],
  Screen: [
    {
      key: 'Dashboard', text: 'داشبورد', value: 18,
    },
    {
      key: 'FoodBank', text: 'بانک خوراکی ها', value: 1,
    },
    {
      key: 'ActivityBank', text: 'بانک فعالیت ها', value: 2,
    },
    {
      key: 'Blog', text: 'مجله', value: 3,
    },
    {
      key: 'PlanFood', text: 'وعده ها', value: 4,
    },
    {
      key: 'Water', text: 'آب شمار', value: 5,
    },
    {
      key: 'Weight', text: 'وزن کشی', value: 6,
    },
    {
      key: 'Contact', text: 'تماس با ما', value: 7,
    },
    {
      key: 'About', text: 'درباره ما', value: 8,
    },
    {
      key: 'Ticket', text: 'تیکت ها', value: 9,
    },
    {
      key: 'Notification', text: 'تنظیمات اعلان', value: 10,
    },
    {
      key: 'FoodDetails', text: 'جزپیات خوارکی', value: 11,
    },
    {
      key: 'ActivityDetails', text: 'جزپیات فعالیت', value: 12,
    },
    {
      key: 'BlogDetails', text: 'جزپیات مقاله', value: 13,
    },
    {
      key: 'PlanActivity', text: 'فعالیت های روزانه', value: 14,
    },
    {
      key: 'Support', text: 'پشتیبانی', value: 15,
    },
    {
      key: 'Exchange', text: 'جایگزینی', value: 16,
    },
    {
      key: 'AppTutorial', text: 'آموزش اپ', value: 17,
    },
    {
      key: 'Diet', text: 'برنامه غذایی', value: 0,
    },
    {
      key: 'FoodRecipes', text: 'دستورپخت', value: 19,
    },
    {
      key: 'FoodSuggestion', text: 'غذای پیشنهادی', value: 20,
    },
    {
      key: 'SportDetails', text: 'دوره ورزشی', value: 21,
    },
    {
      key: 'SportGroup', text: 'گروه ورزشی', value: 22,
    },
    {
      key: 'SportSubGroup', text: 'برنامه ورزشی', value: 23,
    },
    {
      key: 'Videos', text: 'ویدئو', value: 24,
    },
    {
      key: 'VideoDetails', text: 'جزئیات ویدئو', value: 25,
    },
  ],
  Sorting: [
    {
      key: 'Sort', text: 'ترتیب بنرها', value: 0,
    },
    {
      key: 'Random', text: 'رندوم', value: 1,
    },
    {
      key: 'AscendingClick', text: 'کمترین کلیک', value: 2,
    },
    {
      key: 'DescendingClick', text: 'بیشترین کلیک', value: 3,
    },
  ],
  BannerType: [
    {
      key: 'Single', text: 'تکی', value: 0,
    },
    {
      key: 'List', text: 'لیست', value: 1,
    },
    {
      key: 'Slide', text: 'اسلاید', value: 2,
    },
  ],
  ActivityAmountType: [
    {
      key: 'Second', text: 'ثانیه', value: 0,
    },
    {
      key: 'Number', text: 'عدد', value: 1,
    },
  ],
  ActivitySide: [
    {
      key: 'Left', text: 'چپ', value: 0,
    },
    {
      key: 'Right', text: 'راست', value: 1,
    },
  ],
  SicknessCategory: [
    { key: 'Public', text: 'بیماری های عمومی', value: 0 },
    { key: 'JointAndBone', text: 'بیماری های مفصلی و استخوانی', value: 1 },
    { key: 'Digestive', text: 'بیماری های گوارشی', value: 2 },
    { key: 'Nervous', text: 'بیماری های عصبی', value: 3 },
  ],
  FaqCategory: [
    { key: 'Food', text: 'لیست خوراکی ها', value: 0 },
    { key: 'Diet', text: 'دریافت رژیم', value: 1 },
    { key: 'Order', text: 'پرداخت', value: 2 },
    { key: 'Calorie', text: 'کالری شماری', value: 3 },
  ],
  StepType: [
    { key: 'OneFourth', text: 'یک چهارم', value: 0 },
    { key: 'OneThird', text: 'یک سوم', value: 1 },
    { key: 'OneSecond', text: 'یک دوم', value: 2 },
    { key: 'TwoThird', text: 'دو سوم', value: 3 },
    { key: 'ThreeFourth', text: 'سه چهارم', value: 4 },
    { key: 'One', text: 'یک', value: 5 },
  ],
  ActivationType: [
    {
      key: 'Deactive', text: 'غیرفعال', value: 0, badge: 'danger',
    },
    {
      key: 'Active', text: 'فعال', value: 1, badge: 'success',
    },
    {
      key: 'ComingSoon', text: 'به زودی', value: 2, badge: 'secondary',
    },
  ],
  NatureType: [
    {
      key: 'Cool', text: 'سرد', value: 0,
    },
    {
      key: 'Warm', text: 'گرم', value: 1,
    },
    {
      key: 'CoolAndDry', text: 'سرد و خشک', value: 2,
    },
    {
      key: 'CoolAndWet', text: 'سرد و تر', value: 3,
    },
    {
      key: 'WarmAndDry', text: 'گرم و خشک', value: 4,
    },
    {
      key: 'WarmAndWet', text: 'گرم و تر', value: 5,
    },
    {
      key: 'Temperate', text: 'معتدل', value: 6,
    },
  ],
  DietMethod: [
    { key: 'Fat', text: 'افزایش وزن', value: 0 },
    { key: 'Slim', text: 'کاهش وزن', value: 1 },
    { key: 'Fixation', text: 'تثبیت وزن', value: 2 },
  ],
  DietType: [
    { key: 'Vegetable', text: 'رژیم گیاهی', value: 0 },
    { key: 'Unlimited', text: 'رژیم بدون محدودیت', value: 1 },
    { key: 'Ketogenic', text: 'رژیم کتوژنیک', value: 2 },
    { key: 'Public', text: 'رژیم عمومی', value: 3 },
    { key: 'Sickness', text: 'رژیم بیماری', value: 4 },
  ],
  VersionType: [
    {
      key: 'Version', text: 'برنامه', value: 0,
    },
    {
      key: 'Food', text: 'غذا', value: 1,
    },
    {
      key: 'Activity', text: 'فعالیت', value: 2,
    },
  ],
  Platform: [
    {
      key: 'Web', text: 'وب', value: 0,
    },
    {
      key: 'Android', text: 'اندروید', value: 1,
    },
    {
      key: 'iOS', text: 'آیفون', value: 2,
    },
  ],
  UserPermissionIcon: [
    { icon: 'UserIcon', color: 'secondary', key: 'User' },
    { icon: 'ApertureIcon', color: 'info', key: 'Activity' },
    { icon: 'TargetIcon', color: 'primary', key: 'Food' },
    { icon: 'SettingsIcon', color: 'secondary', key: 'Public' },
    { icon: 'PackageIcon', color: 'danger', key: 'Diet' },
    { icon: 'MessageSquareIcon', color: 'warning', key: 'Ticket' },
    { icon: 'DollarSignIcon', color: 'success', key: 'Sale' },
    { icon: 'BookOpenIcon', color: 'primary', key: 'Blog' },
  ],
  TicketStatus: [
    {
      key: 'New', value: 0, text: 'جدید', badge: 'success',
    },
    {
      key: 'UserReply', value: 1, text: 'پاسخ کاربر', badge: 'info',
    },
    {
      key: 'InProgress', value: 2, text: 'در حال بررسی', badge: 'warning',
    },
    {
      key: 'Closed', value: 3, text: 'پاسخ ادمین', badge: 'danger',
    },
    {
      key: 'AdminReply', value: 4, text: 'بسته', badge: 'primary',
    },
  ],
  Lactation: [
    { key: 'None', text: 'هیچ کدام', value: 0 },
    { key: 'FirstSixMonths', text: 'شش ماهه اول', value: 1 },
    { key: 'SecondSixMonths', text: 'شش ماهه دوم', value: 2 },
    { key: 'ThirdSixMonths', text: 'شش ماهه سوم', value: 3 },
    { key: 'FourthSixMonths', text: 'شش ماهه چهارم', value: 4 },
    { key: 'null', text: 'ندارد', value: null },
  ],
  ActivityLevel: [
    { key: 'VeryLight', text: 'خیلی سبک ', value: 0 },
    { key: 'Light', text: 'سبک', value: 1 },
    { key: 'Medium', text: 'متوسط', value: 2 },
    { key: 'Heavy', text: 'سنگین', value: 3 },
    { key: 'VeryHeavy', text: 'خیلی سنگین', value: 4 },
  ],
  Gender: [
    { key: 'Man', text: 'مرد', value: 0 },
    { key: 'Woman', text: 'زن', value: 1 },
  ],
  requiredness: [
    { key: '', text: 'اجباری', value: true },
    { key: '', text: 'اختیاری', value: false },
  ],
  CouponUser: [
    { key: '', text: 'همه', value: false },
    { key: '', text: 'محدود', value: true },
  ],
  DietDifficulty: [
    { key: 'TwoKilosInMonth ', text: 'دو کیلو در ماه', value: 1 },
    { key: 'FourKilosInMonth ', text: 'چهار کیلو در ماه', value: 2 },
    { key: 'null', text: 'ندارد', value: null },
  ],
  bank: [
    { key: 'ZarinPal', text: 'زرین پال', value: 0 },
    { key: 'Bazar', text: 'کافه بازار', value: 1 },
    { key: 'MyKet', text: 'مایکت', value: 2 },
    { key: 'Trial', text: 'آزمایشی', value: 3 },
    { key: 'ByAdmin', text: 'توسط ادمین', value: 4 },
    { key: 'Cart', text: 'کارت به کارت', value: 5 },
    { key: 'Zireh', text: 'زیره', value: 6 },
  ],
  products: [
    {
      key: 'oneMonth', text: 'یک ماهه', value: [14, 1], abr: '1',
    },
    {
      key: 'threeMonth', text: 'سه ماهه', value: [15, 2], abr: '2',
    },
    {
      key: 'sixMonth', text: 'شیش ماهه', value: [16, 3], abr: '3',
    },
    {
      key: 'free', text: 'رایگان', value: [10], abr: '4',
    },
  ],
  durations: [
    { text: '1 روز اخیر', value: 1 },
    { text: '3 روز اخیر', value: 3 },
    { text: '7 روز اخیر', value: 7 },
    { text: '30 روز اخیر', value: 30 },
    { text: '60 روز اخیر', value: 60 },
    { text: '180 روز اخیر', value: 180 },
  ],
  ProductFlavor: [
    { value: 0, text: 'ناشناس' , badge: 'secondary'},
    { value: 1, text: 'استیج' , badge: 'warning'},
    { value: 2, text: 'مستقیم' , badge: 'warning'},
    { value: 3, text: 'گوگل پلی' , badge: 'success'},
    { value: 4, text: 'کافه بازار' , badge: 'success'},
    { value: 5, text: 'مایکت' , badge: 'success'},
    { value: 6, text: 'آی اپس' , badge: 'info'},
    { value: 7, text: 'سیب اپ' , badge: 'info'},
    { value: 8, text: 'اپ استور' , badge: 'info'},
    { value: 9, text: 'وب' , badge: 'primary'},
    { value: 10, text: 'زیروفیت' , badge: 'danger'},
    { value: 11, text: 'پنل' , badge: 'success'},
  ],
  NotificationScale: [
    { value: 0, text: 'تکی' },
    { value: 1, text: 'گروهی' },
  ],
  NotificationsGroups: [
    { value: 0, text: 'کاربران منقضی شده' },
    { value: 1, text: 'کاربران طلایی' },
  ],
  sendVia: [
    { value: 0, text: 'اعلان' },
    { value: 1, text: 'پیامک' }
  ],
  Repeat: [
    { value: true, text: 'فعال' },
    { value: false, text: 'غیرفعال' }
  ],
  notificationStatus: [
    { value: 'draft', text: 'پیش نویس', key: 'draft' },
    { value: 'waitToSent', text: 'در انتظار ارسال', ket: 'waitToSent' },
    { value: 'done', text: 'ارسال شده', key: 'done' },
  ],
  segmentType: [
    { value: 0, text: 'سگمنت پایه', component: 'selectSegmentBasic' },
    { value: 1, text: 'سگمنت سفارشی', component: 'selectSegmentCustom' },
    { value: 2, text: 'اعلان', component: 'selectDeclaration' },
  ],
  BlogContentType: [
    { value: 0, text: 'مقاله با عکس' },
    { value: 1, text: 'مقاله با ویدیو'},
  ],

  archive: [
    { value: true, text: 'غیرفعال' },
    { value: false, text: 'فعال' },
  ],
  errorStatus: [
    { value: false, text: 'باز' },
    { value: true, text: 'بسته' },
  ],
  questionType: [
    { value: 0, key: 'Radio', text: 'تک انتخابی' },
    { value: 1, key: 'Check', text: 'چند انتخابی' },
    { value: 2, key: 'Text', text: 'تشریحی' },
    { value: 3, key: 'Upload', text: 'اپلود' },
    { value: 4, key: 'RadioAndText', text: 'تک انخابی و تشریحی' },
    { value: 5, key: 'CheckAndText', text: 'چند انتخابی و تشریحی' },
    { value: 6, key: 'UploadAndText', text: 'تشریحی و اپلود فایل' },
  ],
}
